export default "__VITE_ASSET__C7f0cUG4__"